import type { FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useModulesContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-modules-context';
// oxlint-disable-next-line no-restricted-imports
import { TopBar as DefaultTopBar } from '@xing-com/top-bar';

import { CreateButton } from './create-button';

export const TopBar: FC = () => {
  const { pageContext } = usePageContext();
  const { hasNewsModule } = useModulesContext();

  const showAction = hasNewsModule && pageContext.isEditor;

  return (
    <DefaultTopBar
      title={pageContext.pageTitle ?? 'XING'}
      subTitle={undefined}
      type="subheader"
      action={showAction && <CreateButton />}
      skipAdditionalButtons
    />
  );
};
